import {
    apiRequest,
    provinsiList,
    provinsiActive,
    provinsiInactive
} from "../../../../../services/adapters/master/provinsiService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", provinsiList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", provinsiInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", provinsiActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository